// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../fragments/commonFragments.generated';
import { PotentialOperationDetailsFragmentDoc } from '../../queries/fragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type TradePartnerContactsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.TradePartnerFilter>;
  includeDeactivated?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type TradePartnerContactsQuery = { __typename?: 'Query', tradePartners: Array<{ __typename?: 'TradePartner', id: string, canLoginToPortal: boolean, contacts: Array<{ __typename?: 'TradePartnerContact', id: string, name: string, title?: string | null | undefined, email?: string | null | undefined, officePhone?: string | null | undefined, mobilePhone?: string | null | undefined, maybeBillingSignatory: boolean, canLoginToPortal: boolean, isActive: boolean, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean }, canDeactivate: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, tradePartner: { __typename?: 'TradePartner', id: string, canLoginToPortal: boolean }, markets: Array<{ __typename?: 'Market', id: string, name: string }>, address?: { __typename?: 'Address', id: string, street1: string, street2?: string | null | undefined, city: string, state: string, postalCode: string, country: string } | null | undefined, tradePartnerUser?: { __typename?: 'TradePartnerUser', id: string } | null | undefined }>, marketContacts: Array<{ __typename?: 'TradePartnerMarketContact', id: string, role: { __typename?: 'TradePartnerMarketRoleDetail', code: Types.TradePartnerMarketRole, name: string }, contact: { __typename?: 'TradePartnerContact', id: string, name: string }, market: { __typename?: 'Market', id: string, name: string }, tradePartner: { __typename?: 'TradePartner', id: string, name: string } }>, markets: Array<{ __typename?: 'Market', id: string, name: string }>, onboardingStatus: { __typename?: 'TradePartnerOnboardingStatusDetail', code: Types.TradePartnerOnboardingStatus } }>, markets: Array<{ __typename?: 'Market', id: string, name: string }> };

export type SaveTradePartnerContactMutationVariables = Types.Exact<{
  input: Types.SaveTradePartnerContactInput;
}>;


export type SaveTradePartnerContactMutation = { __typename?: 'Mutation', saveTradePartnerContact: { __typename?: 'SaveTradePartnerContactResult', tradePartnerContact: { __typename?: 'TradePartnerContact', id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string, contacts: Array<{ __typename?: 'TradePartnerContact', id: string, name: string, title?: string | null | undefined, email?: string | null | undefined, officePhone?: string | null | undefined, mobilePhone?: string | null | undefined, maybeBillingSignatory: boolean, canLoginToPortal: boolean, isActive: boolean, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean }, canDeactivate: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, tradePartner: { __typename?: 'TradePartner', id: string, canLoginToPortal: boolean }, markets: Array<{ __typename?: 'Market', id: string, name: string }>, address?: { __typename?: 'Address', id: string, street1: string, street2?: string | null | undefined, city: string, state: string, postalCode: string, country: string } | null | undefined, tradePartnerUser?: { __typename?: 'TradePartnerUser', id: string } | null | undefined }> } } } };

export type DeleteTradePartnerContactMutationVariables = Types.Exact<{
  input: Types.DeleteTradePartnerContactInput;
}>;


export type DeleteTradePartnerContactMutation = { __typename?: 'Mutation', deleteTradePartnerContact: { __typename?: 'DeleteTradePartnerContactResult', tradePartner: { __typename?: 'TradePartner', id: string, contacts: Array<{ __typename?: 'TradePartnerContact', id: string }> }, tradePartnerContact?: { __typename?: 'TradePartnerContact', id: string, name: string, title?: string | null | undefined, email?: string | null | undefined, officePhone?: string | null | undefined, mobilePhone?: string | null | undefined, maybeBillingSignatory: boolean, canLoginToPortal: boolean, isActive: boolean, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean }, canDeactivate: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, tradePartner: { __typename?: 'TradePartner', id: string, canLoginToPortal: boolean }, markets: Array<{ __typename?: 'Market', id: string, name: string }>, address?: { __typename?: 'Address', id: string, street1: string, street2?: string | null | undefined, city: string, state: string, postalCode: string, country: string } | null | undefined, tradePartnerUser?: { __typename?: 'TradePartnerUser', id: string } | null | undefined } | null | undefined } };

export type SaveTradePartnerMarketContactMutationVariables = Types.Exact<{
  input: Types.SaveTradePartnerMarketContactInput;
}>;


export type SaveTradePartnerMarketContactMutation = { __typename?: 'Mutation', saveTradePartnerMarketContact: { __typename?: 'SaveTradePartnerMarketContactResult', tradePartnerMarketContact: { __typename?: 'TradePartnerMarketContact', id: string, tradePartner: { __typename?: 'TradePartner', id: string, marketContacts: Array<{ __typename?: 'TradePartnerMarketContact', id: string, role: { __typename?: 'TradePartnerMarketRoleDetail', code: Types.TradePartnerMarketRole, name: string }, contact: { __typename?: 'TradePartnerContact', id: string, name: string }, market: { __typename?: 'Market', id: string, name: string }, tradePartner: { __typename?: 'TradePartner', id: string, name: string } }> } } } };

export type ContactsTabTradePartnerFragment = { __typename?: 'TradePartner', id: string, canLoginToPortal: boolean, contacts: Array<{ __typename?: 'TradePartnerContact', id: string, name: string, title?: string | null | undefined, email?: string | null | undefined, officePhone?: string | null | undefined, mobilePhone?: string | null | undefined, maybeBillingSignatory: boolean, canLoginToPortal: boolean, isActive: boolean, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean }, canDeactivate: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, tradePartner: { __typename?: 'TradePartner', id: string, canLoginToPortal: boolean }, markets: Array<{ __typename?: 'Market', id: string, name: string }>, address?: { __typename?: 'Address', id: string, street1: string, street2?: string | null | undefined, city: string, state: string, postalCode: string, country: string } | null | undefined, tradePartnerUser?: { __typename?: 'TradePartnerUser', id: string } | null | undefined }>, marketContacts: Array<{ __typename?: 'TradePartnerMarketContact', id: string, role: { __typename?: 'TradePartnerMarketRoleDetail', code: Types.TradePartnerMarketRole, name: string }, contact: { __typename?: 'TradePartnerContact', id: string, name: string }, market: { __typename?: 'Market', id: string, name: string }, tradePartner: { __typename?: 'TradePartner', id: string, name: string } }>, markets: Array<{ __typename?: 'Market', id: string, name: string }>, onboardingStatus: { __typename?: 'TradePartnerOnboardingStatusDetail', code: Types.TradePartnerOnboardingStatus } };

export type ContactsTabTradePartnerContactFragment = { __typename?: 'TradePartnerContact', id: string, name: string, title?: string | null | undefined, email?: string | null | undefined, officePhone?: string | null | undefined, mobilePhone?: string | null | undefined, maybeBillingSignatory: boolean, canLoginToPortal: boolean, isActive: boolean, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean }, canDeactivate: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, tradePartner: { __typename?: 'TradePartner', id: string, canLoginToPortal: boolean }, markets: Array<{ __typename?: 'Market', id: string, name: string }>, address?: { __typename?: 'Address', id: string, street1: string, street2?: string | null | undefined, city: string, state: string, postalCode: string, country: string } | null | undefined, tradePartnerUser?: { __typename?: 'TradePartnerUser', id: string } | null | undefined };

export type ContactsTabTradePartnerMarketRolesFragment = { __typename?: 'TradePartnerMarketContact', id: string, role: { __typename?: 'TradePartnerMarketRoleDetail', code: Types.TradePartnerMarketRole, name: string }, contact: { __typename?: 'TradePartnerContact', id: string, name: string }, market: { __typename?: 'Market', id: string, name: string }, tradePartner: { __typename?: 'TradePartner', id: string, name: string } };

export type ContactsTabTradePartnerMarketFragment = { __typename?: 'Market', id: string, name: string };

export const ContactsTabTradePartnerContactFragmentDoc = gql`
    fragment ContactsTabTradePartnerContact on TradePartnerContact {
  id
  name
  title
  email
  officePhone
  mobilePhone
  maybeBillingSignatory
  canLoginToPortal
  isActive
  canDelete {
    allowed
  }
  canDeactivate {
    ...PotentialOperationDetails
  }
  tradePartner {
    id
    canLoginToPortal
  }
  markets {
    ...Named
  }
  address {
    id
    street1
    street2
    city
    state
    postalCode
    country
  }
  tradePartnerUser {
    id
  }
}
    ${PotentialOperationDetailsFragmentDoc}
${NamedFragmentDoc}`;
export const ContactsTabTradePartnerMarketRolesFragmentDoc = gql`
    fragment ContactsTabTradePartnerMarketRoles on TradePartnerMarketContact {
  id
  role {
    code
    name
  }
  contact {
    ...Named
  }
  market {
    ...Named
  }
  tradePartner {
    ...Named
  }
}
    ${NamedFragmentDoc}`;
export const ContactsTabTradePartnerMarketFragmentDoc = gql`
    fragment ContactsTabTradePartnerMarket on Market {
  ...Named
}
    ${NamedFragmentDoc}`;
export const ContactsTabTradePartnerFragmentDoc = gql`
    fragment ContactsTabTradePartner on TradePartner {
  id
  canLoginToPortal
  contacts(includeDeactivated: $includeDeactivated) {
    ...ContactsTabTradePartnerContact
  }
  marketContacts {
    ...ContactsTabTradePartnerMarketRoles
  }
  markets {
    ...ContactsTabTradePartnerMarket
  }
  onboardingStatus {
    code
  }
}
    ${ContactsTabTradePartnerContactFragmentDoc}
${ContactsTabTradePartnerMarketRolesFragmentDoc}
${ContactsTabTradePartnerMarketFragmentDoc}`;
export const TradePartnerContactsDocument = gql`
    query TradePartnerContacts($filter: TradePartnerFilter, $includeDeactivated: Boolean) {
  tradePartners(filter: $filter) {
    ...ContactsTabTradePartner
  }
  markets {
    ...Named
  }
}
    ${ContactsTabTradePartnerFragmentDoc}
${NamedFragmentDoc}`;

/**
 * __useTradePartnerContactsQuery__
 *
 * To run a query within a React component, call `useTradePartnerContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradePartnerContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradePartnerContactsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      includeDeactivated: // value for 'includeDeactivated'
 *   },
 * });
 */
export function useTradePartnerContactsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TradePartnerContactsQuery, TradePartnerContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TradePartnerContactsQuery, TradePartnerContactsQueryVariables>(TradePartnerContactsDocument, options);
      }
export function useTradePartnerContactsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TradePartnerContactsQuery, TradePartnerContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TradePartnerContactsQuery, TradePartnerContactsQueryVariables>(TradePartnerContactsDocument, options);
        }
// @ts-ignore
export function useTradePartnerContactsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TradePartnerContactsQuery, TradePartnerContactsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TradePartnerContactsQuery, TradePartnerContactsQueryVariables>;
export function useTradePartnerContactsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradePartnerContactsQuery, TradePartnerContactsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TradePartnerContactsQuery | undefined, TradePartnerContactsQueryVariables>;
export function useTradePartnerContactsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradePartnerContactsQuery, TradePartnerContactsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TradePartnerContactsQuery, TradePartnerContactsQueryVariables>(TradePartnerContactsDocument, options);
        }
export type TradePartnerContactsQueryHookResult = ReturnType<typeof useTradePartnerContactsQuery>;
export type TradePartnerContactsLazyQueryHookResult = ReturnType<typeof useTradePartnerContactsLazyQuery>;
export type TradePartnerContactsSuspenseQueryHookResult = ReturnType<typeof useTradePartnerContactsSuspenseQuery>;
export type TradePartnerContactsQueryResult = Apollo.QueryResult<TradePartnerContactsQuery, TradePartnerContactsQueryVariables>;
export const SaveTradePartnerContactDocument = gql`
    mutation SaveTradePartnerContact($input: SaveTradePartnerContactInput!) {
  saveTradePartnerContact(input: $input) {
    tradePartnerContact {
      id
      name
      tradePartner {
        id
        contacts {
          ...ContactsTabTradePartnerContact
        }
      }
    }
  }
}
    ${ContactsTabTradePartnerContactFragmentDoc}`;
export type SaveTradePartnerContactMutationFn = Apollo.MutationFunction<SaveTradePartnerContactMutation, SaveTradePartnerContactMutationVariables>;

/**
 * __useSaveTradePartnerContactMutation__
 *
 * To run a mutation, you first call `useSaveTradePartnerContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTradePartnerContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTradePartnerContactMutation, { data, loading, error }] = useSaveTradePartnerContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveTradePartnerContactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveTradePartnerContactMutation, SaveTradePartnerContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveTradePartnerContactMutation, SaveTradePartnerContactMutationVariables>(SaveTradePartnerContactDocument, options);
      }
export type SaveTradePartnerContactMutationHookResult = ReturnType<typeof useSaveTradePartnerContactMutation>;
export type SaveTradePartnerContactMutationResult = Apollo.MutationResult<SaveTradePartnerContactMutation>;
export type SaveTradePartnerContactMutationOptions = Apollo.BaseMutationOptions<SaveTradePartnerContactMutation, SaveTradePartnerContactMutationVariables>;
export const DeleteTradePartnerContactDocument = gql`
    mutation DeleteTradePartnerContact($input: DeleteTradePartnerContactInput!) {
  deleteTradePartnerContact(input: $input) {
    tradePartner {
      id
      contacts(includeDeactivated: true) {
        id
      }
    }
    tradePartnerContact {
      ...ContactsTabTradePartnerContact
    }
  }
}
    ${ContactsTabTradePartnerContactFragmentDoc}`;
export type DeleteTradePartnerContactMutationFn = Apollo.MutationFunction<DeleteTradePartnerContactMutation, DeleteTradePartnerContactMutationVariables>;

/**
 * __useDeleteTradePartnerContactMutation__
 *
 * To run a mutation, you first call `useDeleteTradePartnerContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTradePartnerContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTradePartnerContactMutation, { data, loading, error }] = useDeleteTradePartnerContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTradePartnerContactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteTradePartnerContactMutation, DeleteTradePartnerContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteTradePartnerContactMutation, DeleteTradePartnerContactMutationVariables>(DeleteTradePartnerContactDocument, options);
      }
export type DeleteTradePartnerContactMutationHookResult = ReturnType<typeof useDeleteTradePartnerContactMutation>;
export type DeleteTradePartnerContactMutationResult = Apollo.MutationResult<DeleteTradePartnerContactMutation>;
export type DeleteTradePartnerContactMutationOptions = Apollo.BaseMutationOptions<DeleteTradePartnerContactMutation, DeleteTradePartnerContactMutationVariables>;
export const SaveTradePartnerMarketContactDocument = gql`
    mutation SaveTradePartnerMarketContact($input: SaveTradePartnerMarketContactInput!) {
  saveTradePartnerMarketContact(input: $input) {
    tradePartnerMarketContact {
      id
      tradePartner {
        id
        marketContacts {
          ...ContactsTabTradePartnerMarketRoles
        }
      }
    }
  }
}
    ${ContactsTabTradePartnerMarketRolesFragmentDoc}`;
export type SaveTradePartnerMarketContactMutationFn = Apollo.MutationFunction<SaveTradePartnerMarketContactMutation, SaveTradePartnerMarketContactMutationVariables>;

/**
 * __useSaveTradePartnerMarketContactMutation__
 *
 * To run a mutation, you first call `useSaveTradePartnerMarketContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTradePartnerMarketContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTradePartnerMarketContactMutation, { data, loading, error }] = useSaveTradePartnerMarketContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveTradePartnerMarketContactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveTradePartnerMarketContactMutation, SaveTradePartnerMarketContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveTradePartnerMarketContactMutation, SaveTradePartnerMarketContactMutationVariables>(SaveTradePartnerMarketContactDocument, options);
      }
export type SaveTradePartnerMarketContactMutationHookResult = ReturnType<typeof useSaveTradePartnerMarketContactMutation>;
export type SaveTradePartnerMarketContactMutationResult = Apollo.MutationResult<SaveTradePartnerMarketContactMutation>;
export type SaveTradePartnerMarketContactMutationOptions = Apollo.BaseMutationOptions<SaveTradePartnerMarketContactMutation, SaveTradePartnerMarketContactMutationVariables>;